module.exports = __webpack_public_path__ + "img/location.2ff5ccc5.svg";